import {Singleton} from "../../base/singleton";

enum SiteMenuState {
    OPEN = 'open',
    HIDDEN = 'hidden',
}

export class SiteMenuController extends Singleton {
    private readonly menu: HTMLElement;
    private background: HTMLElement;
    private stateAttribute: string = 'data-site-menu-state';
    private state: SiteMenuState = SiteMenuState.HIDDEN;

    private lastStateChange: number = 0;
    private minTimePassed = 500;

    private showBackgroundTimeout: NodeJS.Timeout | undefined;

    protected constructor() {
        super();
        this.menu = document.querySelector('[data-site-menu]') as HTMLElement;
        this.background = document.querySelector('[data-site-menu] .site_menu_bg') as HTMLElement;

        this.update();
        this.onLoad();
    }

    private onLoad() {
        if (this.menu) {
            this.menu.style.display = '';
        }
    }

    private hideBackground() {
        if (this.showBackgroundTimeout) {
            clearTimeout(this.showBackgroundTimeout);
        }
    }

    private showBackground() {
        this.showBackgroundTimeout = setTimeout(() => {
            this.background.style.display = '';
        }, 350);
    }

    private setState(state: SiteMenuState) {
        if (Date.now() < this.lastStateChange + this.minTimePassed) {
            return;
        }

        this.lastStateChange = Date.now();


        const isNewState = this.state !== state;
        if (isNewState) {
            this.state = state;

            if (this.isMenuOpen() && this.isBottomOfPage()) {
                this.hideBackground();
            } else if (!this.isMenuOpen()) {
                this.showBackground();
            }

            this.update();
        }
    }

    private update() {
        this.menu.setAttribute(this.stateAttribute, this.state);
    }

    public isMenuOpen() {
        return this.state === SiteMenuState.OPEN;
    }

    private debounce(func: () => void, timeout = 500) {
        let timer: NodeJS.Timeout;
        return (...args: any) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, timeout);
        };
    }

    public open() {
        this.setState(SiteMenuState.OPEN);
    }

    public close() {
        this.setState(SiteMenuState.HIDDEN);
    }

    public isBottomOfPage() {
        const windowHeight = window.innerHeight;
        const scrollY = window.scrollY;
        const documentHeight = document.body.offsetHeight;

        return windowHeight + scrollY >= documentHeight;
    }
}

